import React from 'react';
import '../../App.css';
import './Lingua.css';
const Lingua = () => {
    
    return (
        <div className="lingua-page">
            
            <div className="lingua-header-container">
                <img
                    src="/images/lingua-header.png"
                    alt="Header"
                    className="lingua-header-image"
                />  
                <h1 className="lingua-title">Lingua</h1>
            </div>
            <div className="lingua-banner"> 
            
                    <div className="main-content">
                        <div id="event-details" className="event-details">
                            <div className="event-details-container">
                                <img
                                    src="/images/lingua-header.png"
                                    alt="LinguA-logo"
                                    className="conference-logo"
                                />
                                <p className="event-date-time">
                                    <strong>Deadline to Apply:</strong><br />
                                    <strong>1 November 2026</strong><br />
                                    <strong>In Person Instruction</strong><br /> 
                                    
                                </p>
                            </div>
              

                            <div id="about-lingua" className="about-lingua">
                                <h2 className="subtitle">ABOUT LinguA</h2>
                                <p className="event-description">
                                    Linguistics Academy (LinguA) is a training program organized by the Bruin Linguists Society at UCLA, designed to introduce high school students to the field of linguistics and prepare for the North American Computational
                                    Linguistics Open Competition (NACLO). Read more about NACLO <a href="./naclo" target="_blank" rel="noopener noreferrer" className="embedded-link"> here</a>.
                                    </p>
                                <p className="event-description">The program features a series of 6 lessons led by UCLA linguistics students and faculty, providing participants with hands-on experience in linguistic challenges in a competition style format.</p>
                                

                                    {/* Sponsors */}
                                    <p className="sponsors">Sponsored by the UCLA Department of Linguistics and the Bruin Linguists Society</p>
                            </div>
                            

                                {/* Keynote Speaker */}
                                <div id="keynote-speaker" className="keynote-speaker">
                                    <h2 className="keynote-title">LinguA Sign Up</h2>
                                   
                                        
                                             
                                             <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfBXMAiiofSLJGyaGxYcO69EY0i4REwsV_SVR3oqczLWzPIPA/viewform?embedded=true" title="LinguA Sign Up" width="100%" height="600" style={{ border: 'none', maxWidth: '640px' }}>Loading…</iframe>
                                             
                                        
                                    </div>
                              </div>

                            <div id="conference-info" className="conference-info">
                            <h2 className="keynote-title">Further Linguistics Academy Information</h2>
                                <p className="normal-text">
                                    Please see below for the official Linguistics Academy Flyer. You can also  <a
                                        href="/LinguA%20Outreach%20Flyer.pdf"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="embedded-link"
                                    >
                                        download the PDF
                                    </a>.
                                </p>
                                <iframe
                                src="/LinguA%20Outreach%20Flyer.pdf"
                                title="LinguA Outreach Flier"
                                width="100%"
                                height="600px"
                                style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                                ></iframe>

                            </div>


                            {/* Contact Information */}
                            <div id="contact-info" className="contact-info">
                                <h2 className="subtitle">CONTACT INFO</h2>
                                <p  style={{ marginBottom: '1.5rem' }}>

                                </p>
                                <p className="normal-text">
                                   If you are have any questions about the Linguistics Academy, don't hesitate to contact Bruin Linguists at <a href="mailto:bruinlinguists@gmail.com" className="email-link">bruinlinguists@gmail.com</a>. Be sure to specify in the subject line that your correspondence is related to LinguA.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>       
    );
};

export default Lingua;

                          